import React from 'react';


const HeartIcon = () => (
  <svg
    id="heart-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--icon-color)"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="heart-icon"
  >
    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z" />
    
  </svg>
);

export default HeartIcon;
